(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const toggle = document.querySelector('.header__menu-toggle');
    const menu = document.getElementById('mobile-menu');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function() {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      menu.setAttribute('aria-expanded', String(!expanded));
    });

    const header = document.querySelector('.header[data-sticky="true"]');
    if (header) {
      let lastScroll = 0;
      window.addEventListener('scroll', function() {
        const current = window.scrollY;
        if (current > 60) {
          header.classList.add('is-scrolled');
        } else {
          header.classList.remove('is-scrolled');
        }
        lastScroll = current;
      }, { passive: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-burst"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hero powder-burst — scroll-scrubbed canvas image sequence (73 frames).
   *
   * Loading strategy (reescrito 2026-08-21, tras un visitante que reportó que
   * el hero "no le cargó"). La versión anterior disparaba las 73 descargas
   * apenas corría el script. Como esas peticiones arrancan ANTES del evento
   * `load`, lo retrasan: medido 51,7 s contra melocolombia.com en un enlace de
   * ~1,5 Mbps, con el último frame llegando a los 50,8 s. Y mientras llegaban,
   * el canvas se quedaba congelado en un frame viejo. Ahora:
   *   1. no se pide un solo frame hasta que `load` ya disparó → nunca lo bloquea;
   *   2. los frames llegan en pasadas de grueso a fino (stride 16→8→4→2→1), así
   *      el burst completo es raspable con ~5 imágenes en vez de con las 73;
   *   3. draw() cae al frame más cercano que YA esté en memoria, así la
   *      animación degrada a "escalonada" en vez de a "congelada";
   *   4. en conexiones 3g o peores se omite la última pasada (la mitad del peso);
   *   5. con ahorro de datos / 2g / reduced-motion se queda el póster estático y
   *      la sección se colapsa a una pantalla (sin scroll muerto).
   * No puede contener Liquid; las URLs vienen del
   * <script type="application/json" data-burst-frames>.
   */
  (function () {
    'use strict';

    var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function conn() {
      return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
    }

    // Ahorro de datos explícito o red muy mala => ni intentarlo.
    function dataSaver() {
      var c = conn();
      if (!c) return false;
      if (c.saveData) return true;
      var t = c.effectiveType || '';
      return t === 'slow-2g' || t === '2g';
    }

    // 3g (o menos) => se carga la mitad de los frames: sigue siendo fluido al
    // raspar y ahorra ~1,9 MB.
    function lightMode() {
      var c = conn();
      if (!c) return false;
      var t = c.effectiveType || '';
      return t === '3g' || t === 'slow-2g' || t === '2g';
    }

    function staticOnly() {
      return (reduceMQ && reduceMQ.matches) || dataSaver();
    }

    function idle(fn) {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2000 });
      else setTimeout(fn, 300);
    }

    // Clave del arreglo: nada se pide hasta que la página terminó de cargar.
    function afterLoad(fn) {
      if (document.readyState === 'complete') idle(fn);
      else window.addEventListener('load', function () { idle(fn); });
    }

    function initBurst(wrap) {
      if (wrap.__burstInit) return;

      var canvas = wrap.querySelector('[data-burst-canvas]');
      var dataEl = wrap.querySelector('[data-burst-frames]');
      if (!canvas || !dataEl) return;

      var urls;
      try { urls = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!urls || !urls.length) return;

      wrap.__burstInit = true;

      // Contextos estáticos: póster, sin scroll muerto, sin descargar nada.
      if (staticOnly()) { wrap.classList.add('hero-burst--static'); return; }
      wrap.classList.remove('hero-burst--static');

      var ctx = canvas.getContext('2d');
      var N = urls.length;
      var poster = wrap.querySelector('[data-burst-poster]');
      var hint = wrap.querySelector('[data-burst-hint]');
      var scrubVh = parseFloat(wrap.getAttribute('data-scrub-vh')) || 100;

      var IDLE = 0, LOADING = 1, READY = 2, FAILED = 3;
      var state = new Array(N);
      var cbs = new Array(N);
      var images = new Array(N);
      for (var z = 0; z < N; z++) state[z] = IDLE;

      var drawn = -1;    // frame pintado ahora mismo en el canvas
      var want = 0;      // frame que pide la posición de scroll
      var started = false; // la cola no arranca hasta después del evento load
      var inFlight = 0;
      var MAX_PARALLEL = 6;
      var hintHidden = false;

      // Nunca dejar el canvas en un frame viejo: si el exacto no llegó, se
      // pinta el más cercano que sí esté en memoria.
      function nearestReady(i) {
        if (state[i] === READY) return i;
        for (var d = 1; d < N; d++) {
          if (i - d >= 0 && state[i - d] === READY) return i - d;
          if (i + d < N && state[i + d] === READY) return i + d;
        }
        return -1;
      }

      function paint(i) {
        if (i < 0 || i === drawn || state[i] !== READY) return;
        ctx.drawImage(images[i], 0, 0, canvas.width, canvas.height);
        drawn = i;
        if (poster && poster.style.opacity !== '0') poster.style.opacity = '0';
      }

      function render() { paint(nearestReady(want)); }

      function settle(i) {
        inFlight--;
        var list = cbs[i];
        cbs[i] = null;
        if (list) for (var k = 0; k < list.length; k++) list[k](i);
        pump();
      }

      function load(i, cb) {
        if (i < 0 || i >= N) return;
        var s = state[i];
        if (s === READY) { if (cb) cb(i); return; }
        if (s === FAILED) return;
        // Ya está en vuelo: encolar el callback (antes se descartaba, y por eso
        // el frame nunca se pintaba cuando por fin llegaba).
        if (cb) cbs[i] = (cbs[i] || []).concat([cb]);
        if (s === LOADING) return;

        state[i] = LOADING;
        inFlight++;
        var im = new Image();
        im.decoding = 'async';
        im.onload = function () { state[i] = READY; settle(i); };
        im.onerror = function () { state[i] = FAILED; settle(i); };
        im.src = urls[i];
        images[i] = im;
      }

      // Orden de descarga: de grueso a fino. Con la primera pasada (stride 16)
      // ya se puede raspar el burst de principio a fin.
      var queue = (function () {
        var strides = lightMode() ? [16, 8, 4, 2] : [16, 8, 4, 2, 1];
        var seen = {}, order = [], p, i;
        for (p = 0; p < strides.length; p++) {
          for (i = 0; i < N; i += strides[p]) {
            if (!seen[i]) { seen[i] = 1; order.push(i); }
          }
        }
        if (!seen[N - 1]) order.push(N - 1);   // el frame final siempre
        return order;
      })();
      var qi = 0;

      function pump() {
        // Ojo: settle() también llama aquí para encadenar la siguiente descarga,
        // así que la compuerta tiene que estar DENTRO de pump, no solo en la
        // primera llamada. Sin esto, el frame 1 al cargar destapaba las 73.
        if (!started) return;
        while (inFlight < MAX_PARALLEL && qi < queue.length) {
          var i = queue[qi++];
          if (state[i] !== IDLE) continue;
          load(i, render);
        }
      }

      // Frame 1 = misma URL que el póster (viene de caché, no cuesta nada).
      load(0, render);
      afterLoad(function () { started = true; pump(); });

      var stage = wrap.querySelector('.hero-burst__stage');
      var lastPad = -1;

      var ticking = false;
      function update() {
        ticking = false;
        var rect = wrap.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;

        // Mientras la etapa no se ancla arriba, se reserva abajo justo lo que le
        // falta, para que el contenido quepa en lo que se ve. Al anclarse vale 0.
        if (stage) {
          var pad = Math.round(stage.getBoundingClientRect().top);
          if (pad < 0) pad = 0;
          if (pad !== lastPad) { wrap.style.setProperty('--pin-pad', pad + 'px'); lastPad = pad; }
        }
        var scrubPx = vh * (scrubVh / 100);
        var progress = scrubPx > 0 ? (-rect.top) / scrubPx : 0;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        if (hint && !hintHidden && progress > 0.02) { hint.style.opacity = '0'; hintHidden = true; }
        if (hint && hintHidden && progress <= 0.02) { hint.style.opacity = ''; hintHidden = false; }

        want = Math.round(progress * (N - 1));
        render();                 // lo mejor que haya ahora mismo
        load(want, render);       // y el exacto se adelanta en la cola
      }

      function onScroll() {
        if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.requestAnimationFrame(update);

      wrap.__burstTeardown = function () {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        wrap.__burstInit = false;
        wrap.__burstTeardown = null;
      };
    }

    function boot(scope) {
      var root = (scope && scope.querySelectorAll) ? scope : document;
      var list = root.querySelectorAll('[data-hero-burst]');
      for (var i = 0; i < list.length; i++) initBurst(list[i]);
    }

    function rebootAll() {
      var list = document.querySelectorAll('[data-hero-burst]');
      for (var i = 0; i < list.length; i++) {
        var w = list[i];
        if (typeof w.__burstTeardown === 'function') w.__burstTeardown();
        w.__burstInit = false;
        initBurst(w);
      }
    }

    // Solo reduced-motion re-inicializa. (El breakpoint móvil ya no cambia el
    // comportamiento, y rebotar en cada resize obligaba a redescargar todo.)
    if (reduceMQ) {
      if (reduceMQ.addEventListener) reduceMQ.addEventListener('change', rebootAll);
      else if (reduceMQ.addListener) reduceMQ.addListener(rebootAll);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    document.addEventListener('shopify:section:load', function (e) { boot(e.target || document); });
    document.addEventListener('shopify:section:unload', function (e) {
      var scope = e.target || document;
      var list = scope.querySelectorAll ? scope.querySelectorAll('[data-hero-burst]') : [];
      for (var i = 0; i < list.length; i++) {
        if (typeof list[i].__burstTeardown === 'function') list[i].__burstTeardown();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  /*
   * Hero 3D turntable - progressive-enhancement fallback.
   *
   * DELIBERATE DEVIATION from the theme's zero-JS philosophy: CSS scroll-driven
   * animations (animation-timeline / view()) are NOT reliably supported in
   * Safari / Firefox as of early 2026, so this tiny passive script reproduces
   * the effect by setting the SHARED --frame custom property from the hero's
   * scroll position. The CSS opacity calc reads --frame either way, so both the
   * CSS-animated path and this JS path drive identical visibility.
   *
   * It also self-heals the "browser reports support but does not actually
   * advance the timeline" case: after boot it verifies a real timeline-bound
   * animation exists and is producing a value; if not, it takes over the scrub.
   *
   * Note: {% javascript %} is concatenated once globally (not per section) and
   * cannot contain Liquid, so every turntable is discovered via the DOM.
   */
  (function () {
    'use strict';

    var reducedMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var mobileMQ = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;

    var CSS_DRIVEN = false;
    try {
      CSS_DRIVEN = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
    } catch (e) {
      CSS_DRIVEN = false;
    }

    function isPinned() {
      return (reducedMQ && reducedMQ.matches) || (mobileMQ && mobileMQ.matches);
    }

    function setFrame(turntable, frames, index) {
      if (index < 1) index = 1;
      if (index > frames.length) index = frames.length;
      // The SHARED signal. The CSS opacity calc does the rest.
      turntable.style.setProperty('--frame', index);
    }

    // Verify the CSS scroll-driven path is actually live on this node: a frame
    // (or the turntable) must have an animation bound to a real timeline that is
    // producing a numeric currentTime. Guards the "claims support but does
    // nothing" UAs (flag-gated / partial implementations).
    function cssScrubActuallyWorks(turntable) {
      try {
        var nodes = [turntable];
        if (typeof turntable.getAnimations !== 'function') return false;
        for (var n = 0; n < nodes.length; n++) {
          var anims = nodes[n].getAnimations ? nodes[n].getAnimations() : [];
          for (var a = 0; a < anims.length; a++) {
            var anim = anims[a];
            if (anim && anim.timeline && anim.timeline !== document.timeline) {
              // A non-document (scroll/view) timeline is attached. Good enough.
              return true;
            }
          }
        }
      } catch (e) {}
      return false;
    }

    function initTurntable(turntable) {
      if (turntable.__heroTurntableInit) return;
      turntable.__heroTurntableInit = true;

      var frames = turntable.querySelectorAll('.hero__frame');
      if (!frames.length) {
        turntable.__heroTurntableInit = false;
        return;
      }

      var count = parseInt(turntable.getAttribute('data-frame-count'), 10) || frames.length;
      count = Math.min(count, frames.length);

      var section = turntable.closest('.hero') || turntable;
      var staticIndex = Math.min(6, count); // front-centred pose

      // Reduced motion or mobile: pin the static front frame, never scrub.
      // CSS also forces this via !important; we set --frame for parity.
      if (isPinned()) {
        setFrame(turntable, frames, staticIndex);
        return;
      }

      setFrame(turntable, frames, staticIndex);

      var ticking = false;

      function update() {
        ticking = false;
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;

        // Progress 0..1 as the section travels from entering the bottom of the
        // viewport to leaving the top - mirrors the CSS view() cover range.
        var total = rect.height + vh;
        var progress = total > 0 ? (vh - rect.top) / total : 0;
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        var index = Math.floor(progress * count) + 1;
        if (index > count) index = count;
        setFrame(turntable, frames, index);
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      var listening = false;
      function startListening() {
        if (listening) return;
        listening = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
      }
      function stopListening() {
        if (!listening) return;
        listening = false;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              startListening();
              update();
            } else {
              stopListening();
            }
          }
        }, { threshold: 0 });
        io.observe(section);
        turntable.__heroTurntableTeardown = function () {
          stopListening();
          io.disconnect();
          turntable.__heroTurntableInit = false;
        };
      } else {
        startListening();
        update();
        turntable.__heroTurntableTeardown = function () {
          stopListening();
          turntable.__heroTurntableInit = false;
        };
      }
    }

    function teardown(turntable) {
      if (typeof turntable.__heroTurntableTeardown === 'function') {
        turntable.__heroTurntableTeardown();
      }
    }

    function bootNode(turntable) {
      // Pinned (reduced-motion / mobile): JS pins the front frame; the CSS path
      // is neutralised by !important regardless.
      if (isPinned()) {
        initTurntable(turntable);
        return;
      }

      // Not pinned. If CSS claims scroll-driven support, give it a moment to
      // attach a real timeline; if it never does, take over with JS so we never
      // silently render a stuck frame.
      if (CSS_DRIVEN) {
        var verify = function () {
          if (turntable.__heroTurntableInit) return; // JS already running
          if (cssScrubActuallyWorks(turntable)) return; // CSS is doing the job
          initTurntable(turntable);
        };
        if ('requestAnimationFrame' in window) {
          window.requestAnimationFrame(function () { window.requestAnimationFrame(verify); });
        } else {
          verify();
        }
        return;
      }

      // No CSS scroll-driven support at all: JS scrub.
      initTurntable(turntable);
    }

    function boot(scope) {
      var root = (scope && scope.querySelectorAll) ? scope : document;
      var turntables = root.querySelectorAll('[data-hero-turntable]');
      for (var i = 0; i < turntables.length; i++) {
        bootNode(turntables[i]);
      }
    }

    // Re-evaluate every turntable when the pinned state could have flipped
    // (viewport crosses 768px, or the reduced-motion preference changes). Tear
    // down any running JS scrub and re-boot so we start/stop scrubbing without a
    // full reload, and so the DOM state matches what CSS renders.
    function reboot() {
      var turntables = document.querySelectorAll('[data-hero-turntable]');
      for (var i = 0; i < turntables.length; i++) {
        teardown(turntables[i]);
        bootNode(turntables[i]);
      }
    }

    function onMQChange() { reboot(); }

    function bindMQ(mq) {
      if (!mq) return;
      if (mq.addEventListener) {
        mq.addEventListener('change', onMQChange);
      } else if (mq.addListener) {
        mq.addListener(onMQChange); // older Safari
      }
    }
    bindMQ(reducedMQ);
    bindMQ(mobileMQ);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { boot(document); });
    } else {
      boot(document);
    }

    // Theme editor: (re)initialise only the reloaded section, and tear down
    // listeners when a section is removed so nothing leaks across edits.
    document.addEventListener('shopify:section:load', function (event) {
      boot(event.target || document);
    });
    document.addEventListener('shopify:section:unload', function (event) {
      var scope = event.target || document;
      var turntables = scope.querySelectorAll
        ? scope.querySelectorAll('[data-hero-turntable]')
        : [];
      for (var i = 0; i < turntables.length; i++) {
        teardown(turntables[i]);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.collection-section');
    if (!section) return;

    /* Sort select */
    var sortSelect = section.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* Filter toggle on mobile */
    var filterToggle = section.querySelector('[data-filter-toggle]');
    var filtersSidebar = section.querySelector('[data-filters-sidebar]');

    if (filterToggle && filtersSidebar) {
      filterToggle.addEventListener('click', function() {
        var isOpen = filtersSidebar.classList.toggle('is-open');
        filterToggle.setAttribute('aria-expanded', isOpen);
      });
    }

    /* Filter form submission */
    var filterForm = section.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(filterForm);
        var url = new URL(window.location.pathname, window.location.origin);
        formData.forEach(function(value, key) {
          if (value) url.searchParams.append(key, value);
        });
        var currentSort = new URL(window.location.href).searchParams.get('sort_by');
        if (currentSort) url.searchParams.set('sort_by', currentSort);
        window.location.href = url.toString();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-section-id]');
    if (!section) return;

    var variantsJSON = section.querySelector('[data-product-variants]');
    if (!variantsJSON) return;

    var variants = JSON.parse(variantsJSON.textContent);
    var mainImage = section.querySelector('[data-main-image]');
    var mainMedia = section.querySelector('[data-main-media]');
    var thumbnails = section.querySelectorAll('[data-thumbnail]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var variantIdInput = section.querySelector('[data-variant-id-input]');
    var priceDisplay = section.querySelector('[data-product-price]');
    var optionInputs = section.querySelectorAll('[data-option-input]');
    var sellingPlanInputs = section.querySelectorAll('[data-selling-plan-input]');
    var sellingPlanHidden = section.querySelector('[data-selling-plan-hidden]');

    /* --- Variant selection --- */
    function getSelectedOptions() {
      var options = [];
      var fieldsets = section.querySelectorAll('.variant-picker');
      fieldsets.forEach(function(fieldset) {
        var checked = fieldset.querySelector('input:checked');
        if (checked) options.push(checked.value);
      });
      return options;
    }

    function findVariant(selectedOptions) {
      return variants.find(function(variant) {
        return variant.options.every(function(opt, i) {
          return opt === selectedOptions[i];
        });
      });
    }

    function updateVariant(variant) {
      if (!variant) return;

      /* Update price */
      if (priceDisplay) {
        priceDisplay.innerHTML = Shopify.formatMoney ? Shopify.formatMoney(variant.price) : ('$' + (variant.price / 100).toFixed(2));
      }

      /* Update hidden input */
      if (variantIdInput) {
        variantIdInput.value = variant.id;
      }

      /* Update add-to-cart button */
      if (addToCartBtn) {
        addToCartBtn.disabled = !variant.available;
        addToCartBtn.textContent = variant.available
          ? addToCartBtn.dataset.addText || addToCartBtn.textContent
          : addToCartBtn.dataset.soldText || addToCartBtn.textContent;
      }

      /* Update URL */
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());

      /* Update gallery image if variant has media */
      if (variant.featured_media && mainImage) {
        var targetThumb = section.querySelector('[data-media-id="' + variant.featured_media.id + '"]');
        if (targetThumb) {
          selectThumbnail(targetThumb);
        }
      }
    }

    /* --- Option pills --- */
    optionInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        /* Update pill visual state */
        var parent = input.closest('.variant-picker__options');
        if (parent) {
          parent.querySelectorAll('.variant-picker__pill').forEach(function(pill) {
            pill.classList.remove('variant-picker__pill--selected');
          });
          input.closest('.variant-picker__pill').classList.add('variant-picker__pill--selected');
        }

        var selected = getSelectedOptions();
        var variant = findVariant(selected);
        if (variant) updateVariant(variant);
      });
    });

    /* --- Selling plan --- */
    sellingPlanInputs.forEach(function(input) {
      input.addEventListener('change', function() {
        if (sellingPlanHidden) {
          sellingPlanHidden.value = input.value;
        }
      });
    });

    /* --- Gallery thumbnails --- */
    function selectThumbnail(thumb) {
      thumbnails.forEach(function(t) { t.classList.remove('product__thumbnail--active'); });
      thumb.classList.add('product__thumbnail--active');
      if (mainImage) {
        mainImage.src = thumb.dataset.mediaSrc;
        mainImage.alt = thumb.dataset.mediaAlt || '';
      }
    }

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        selectThumbnail(thumb);
      });
    });

    /* --- Quantity buttons --- */
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');

    if (qtyInput && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val < 99) qtyInput.value = val + 1;
      });
    }

    /* --- Tabbed Description --- */
    var tabbedContainers = section.querySelectorAll('[data-tabbed-description]');
    tabbedContainers.forEach(function(container) {
      var tabs = container.querySelectorAll('[data-tab]');
      var panels = container.querySelectorAll('[data-panel]');

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var targetPanel = tab.dataset.tab;

          tabs.forEach(function(t) {
            t.classList.remove('tabbed-description__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('tabbed-description__tab--active');
          tab.setAttribute('aria-selected', 'true');

          panels.forEach(function(panel) {
            if (panel.dataset.panel === targetPanel) {
              panel.classList.add('tabbed-description__panel--active');
              panel.removeAttribute('hidden');
            } else {
              panel.classList.remove('tabbed-description__panel--active');
              panel.setAttribute('hidden', '');
            }
          });
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
